module.exports = __webpack_public_path__ + "img/incein-l-circle-1.2ecd7204.svg";